import { render, staticRenderFns } from "./InsuranceDictionaryMngt.vue?vue&type=template&id=3105c53c"
import script from "./InsuranceDictionaryMngt.vue?vue&type=script&lang=js"
export * from "./InsuranceDictionaryMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports